import { useQuery } from "@/api/swr/useQuery";
import { regularAssessmentDetailSchema } from "@/schema/console/regular-assessments/RegularAssessmentDetail";

type Config = Parameters<
  typeof useQuery<typeof regularAssessmentDetailSchema>
>[2];

export function useGetLatestRegularAssessment(config: Config) {
  return useQuery(
    regularAssessmentDetailSchema,
    `/console/assessment_papers/latest?is_premium=true`,
    config,
  );
}
